export default {
    props: {
        animationCollapseDuration: {
            type: Number,
            default: undefined,
            kComposite: 'animation.collapse.duration'
        }, 
        animationCollapseEffects: {
            type: String,
            default: undefined,
            kComposite: 'animation.collapse.effects'
        }, 
        animationExpandDuration: {
            type: Number,
            default: undefined,
            kComposite: 'animation.expand.duration'
        }, 
        animationExpandEffects: {
            type: String,
            default: undefined,
            kComposite: 'animation.expand.effects'
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-layout-vue-wrapper/src/KendoPanelBar/Animation.js